module.exports = __webpack_public_path__ + "img/search-home-white.f50c773d.svg";